import { FormItemProps } from 'antd';

/** @see https://github.com/ant-design/ant-design/issues/21563 */
export const normFile: FormItemProps['getValueFromEvent'] = (event) => {
    if (Array.isArray(event))
        return event;
              
    return event?.fileList;
};